module.exports = __webpack_public_path__ + "static/img/ic_roadview_on@2x.4a45956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_roadview_on@2x.png
// module id = AcH4
// module chunks = 1